module.exports = {
	title: 'Footer',
	context: {
		content: `
			<p>
				Lorem ipsum dolor sit amet, cum alii delenit fierent id, enim esse inermis vix ex. Te qui regione scriptorem, nihil quaeque quo at. In eam suscipit imperdiet appellantur. Cu iisque tractatos sit, duo sint quodsi utroque ea. Eruditi persequeris id vix.
			</p>`,
		info: `
			<p>
				Försvarets materielverk <br>
				115 88 Stockholm<br>
				Telefon: +46 8 782 40 00<br>
				Fax: +46 8 667 57 99<br>
				E-post: <a href="#">registrator@fmv.se</a><br>
			</p>
		`,
		nav: [
			'FMV:S nyhetsbrev',
			'Kontakt FMV',
			'Grafisk Profil',
			'Om webbplatsen',
			'Behandling av personuppgifter',
		],
	},
};
